import React from 'react';
import { PassData } from './types';

// "What you'll get" checklist. Copy adapts to the pass type so a coupon
// doesn't promise loyalty points; all variants stay generic enough to be
// true for any merchant (no unverifiable claims).
const BENEFITS_BY_TYPE: Record<string, string[]> = {
  loyalty: [
    'Your card always with you — no app needed',
    'Exclusive member offers',
    'Updates and new offers on your pass',
    'Easy access in store',
  ],
  gift_card: [
    'Your gift card always with you — no app needed',
    'Balance shown right on the pass',
    'Updates and new offers on your pass',
    'Easy redemption in store',
  ],
  coupon: [
    'Your offer always with you — no app needed',
    'Never lose the code — it lives in your wallet',
    'Updates if the offer changes',
    'Easy redemption in store',
  ],
  event_ticket: [
    'Your ticket always with you — no app needed',
    'Quick entry with the barcode on your pass',
    'Updates if event details change',
    'No printing required',
  ],
};

const BenefitsList: React.FC<{ passData: PassData }> = ({ passData }) => {
  const items = BENEFITS_BY_TYPE[passData.pass_type || 'loyalty'] || BENEFITS_BY_TYPE.loyalty;
  return (
    <ul className="space-y-3">
      {items.map((text) => (
        <li key={text} className="flex items-start gap-3">
          <span className="mt-0.5 w-5 h-5 rounded-full bg-[#AEDD1F] text-[#06251B] flex items-center justify-center shrink-0">
            <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <path d="M5 13l4 4L19 7" />
            </svg>
          </span>
          <span className="text-sm text-gray-700">{text}</span>
        </li>
      ))}
    </ul>
  );
};

export default BenefitsList;
